
import React, { useEffect, useState } from 'react';
import Layout, { LayoutProps } from 'components/layout';
import { useHistory, useLocation } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import CopyrightInfomration from 'components/copyright-information';
import { addAgentCode, redirectToOld } from '__utils/common-utils';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import RiskProfileViewSelector from 'views/investor-profile/risk-profile/risk-profile.selector';
import styled from 'styled-components';
import { getUserDetails } from '__utils/storage';
import elementVisibilty from '__utils/toggleVisibilty-util';
import { GreenButtonSmall } from 'components/button';
import noUserIcon from "images/no_user_icon.png";

const DashboardContainer = styled.div`

`;

const ProfileDashboardLayout: React.FC<LayoutProps> = (props: LayoutProps) => {
    const history = useHistory();
    const location = useLocation();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { riskProfileResult } = propsToJS(useSelector(RiskProfileViewSelector));
    
    const majorStatus = sessionStorage.getItem('majorStatus') || '';

    useEffect(() => {
        const linkTitle = location.pathname.split("/");
        const newElement: HTMLElement | null = document.getElementById(`${linkTitle.slice(-1)}Link`);
        if(!majorStatus) newElement?.classList.add('active');
      
    }, [])

    const goTo = (url: string) =>{
        history.push((addAgentCode(url)));
    }

    return (
        <div>
            <Layout config={props?.config} breadcrumbList={[{ text: 'Home', url: 'v1/home', isExternal: true }, { text: 'Account', url: '' }]} desktopWidth='1240px'>  
               <DashboardContainer>
                    {!isMobile && <div className="innerContainer" >
                        <section className="accHead group">
                            <h1>Account & Settings</h1>
                        </section>
                        <div className="group">
                            <aside className="accountSidebarNav">
                                <ul>
                                    <li><a className={majorStatus ? 'disabledBtn' : ''} onClick={() => goTo("/profile")} id="profileLink">Profile</a></li>
                                    <li><a className={majorStatus ? 'disabledBtn' : ''} onClick={() =>
                                        riskProfileResult ? goTo('/profile/risk-profile-result?flowType=profile') :
                                            goTo('/profile/risk-profile?flowType=profile')} id={ riskProfileResult ? "risk-profile-resultLink" : "risk-profileLink"}>Risk Profile</a></li>
                                    <li><a className={majorStatus ? 'disabledBtn' : ''} onClick={() => goTo("/profile/portfolio")}  id="portfolioLink">Portfolio</a></li>
                                    <li><a className={majorStatus ? 'disabledBtn' : ''} onClick={() => redirectToOld(addAgentCode("running-sips"))} id="runningLink">My SIPs</a></li>
                                    <li><a className={majorStatus ? 'disabledBtn' : ''} onClick={() => redirectToOld(addAgentCode("transaction"))} id="transactionLink">Transactions</a></li>
                                    <li><a className={majorStatus ? 'disabledBtn' : ''} onClick={() => goTo("/profile/mandates")} id="mandatesLink">Mandates</a></li>
                                    <li><a className={majorStatus ? 'disabledBtn' : ''} onClick={() => goTo("/profile/stps")} id="stpsLink">My STPs</a></li>
                                </ul>
                            </aside>
                            {getUserDetails() || (majorStatus && window.location.pathname === '/v1/profile/portfolio') ?
                                <div className="profileContainer">
                                    <div style={{ flex: '1 0 100%' }}> {props?.children} </div>
                                </div>
                                : <section className="noMsgBoxInner accContent">
                                    <div className="noMsgBox">
                                        <img src={noUserIcon} alt="no user" />
                                        <h2 style={{ fontSize: "16px", margin: '10px' }}>You are not authorized to view this page.</h2>
                                        <GreenButtonSmall onClick={() => elementVisibilty.show('loginDiv')}>LOGIN/REGISTER</GreenButtonSmall>
                                        <p>OR</p>
                                        Please contact help@turtlemintmoney.com for more information.
                                    </div>
                                </section>}
                        </div>
                    </div>}
                    {
                        isMobile && <div>{props?.children}</div>
                    }
                </DashboardContainer>
            </Layout >
            {!isMobile && <div style={{ width: "100%" }}><CopyrightInfomration /></div>
            }
        </div>);
};

export default ProfileDashboardLayout;


